import React, { Component } from 'react'
// import classes from './SetupThresholdGroup.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
// import Button from '../../../../components/UI/Button/Button'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/ForceRankGroup/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import { Edit, Delete, Add } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
import moment from 'moment'
class ForceRankGroup extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    action: 'add',
    addAno: false,
    actionRecordId: null,
    formValid: false,
    totalValid: false,
    searchText: '',
    withSeq: true,
    filter: {},
    inputGroups: {
      fr_group_name: {
        label: this.props.translate('forceRankGroupName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('forceRankGroupName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      effective_date: {
        label: this.props.translate('effectiveDate'),
        elementType: 'datePicker',
        elementConfig: {
          type: 'text'
        },
        value: moment(new Date(), 'YYYY-MM-DD').format('DD MMM YYYY'),
        validation: {
          required: true,
          type: 'date'
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: [
            { value: '', label: this.props.translate('select') + this.props.translate('company') }
          ]
        }
      },
      fr_group_id: {
        label: this.props.translate('forceRankGroupName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('forceRankGroupName'),
          options: [
            {
              value: '',
              label: this.props.translate('select') + this.props.translate('forceRankGroupName')
            }
          ]
        }
      }
    },
    groups: {
      start_value: {
        label: this.props.translate('start'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('thresholdGroup')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      end_value: {
        label: this.props.translate('end'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('end')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      },
      color_code: {
        label: this.props.translate('colorCode'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('colorCode')
        },
        value: '',
        validation: {
          required: false
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    grade: [],
    updateProps: {
      companyOptions: this.props.companyOptions,
      filterForceRankGroup: this.props.filterForceRankGroup,
      selectedRecord: this.props.selectedRecord
    }
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('forceRankGroup'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true
      //   disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('forceRankGroup'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.fr_group_id)
      //   disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('forceRankGroup'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.fr_group_id)
      //   disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    {
      field: 'fr_group_name',
      title: this.props.translate('forceRankGroupName'),
      type: 'string'
    },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'effective_date',
      title: this.props.translate('effectiveDate'),
      type: 'string'
    }
  ]

  componentDidMount() {
    this.props.fetchOptions()
    this.props.fetchForceRankGroup()
  }
  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }
  static getDerivedStateFromProps = (props, state) => {
    let updatedState = {}
    let { updateProps } = state

    const updateOptions = (stateId, propsId, attr, withCode) => {
      const inputGroups = state.inputGroups
      const targetOrgGroupItem = inputGroups[stateId]
      let [attrId, attrCode, attrName, attrPlaceHolder] = attr

      updatedState = updateObject(updatedState, {
        inputGroups: updateObject(inputGroups, {
          [stateId]: updateFormOptions(
            props[propsId],
            targetOrgGroupItem,
            attrId,
            attrId,
            attrName,
            attrPlaceHolder,
            null,
            null,
            withCode ? attrCode : null
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    const updateFilter = (stateId, propsId, attr) => {
      let [attrId, attrName] = attr
      let value = state.filterControls[stateId].value
      if (props[propsId].length === 0) {
        value = 'No Data'
      }
      updatedState = updateObject(updatedState, {
        filterControls: updateObject(state.filterControls, {
          [stateId]: updateFilterOptions(
            props[propsId],
            state.filterControls[stateId],
            attrId,
            attrId,
            attrName,
            null,
            null,
            value
          )
        }),
        updateProps: updateObject(updateProps, { [propsId]: props[propsId] })
      })
    }
    if (props.companyOptions !== updateProps.companyOptions) {
      updateOptions('company_id', 'companyOptions', [
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      ])
      updateFilter('company_id', 'companyOptions', [
        'company_id',
        { code: 'company_code', name: 'company_name' }
      ])
    }
    if (props.filterForceRankGroup !== updateProps.filterForceRankGroup) {
      updateFilter('fr_group_id', 'filterForceRankGroup', ['fr_group_id', 'fr_group_name'])
    }
    if (props.selectedRecord !== updateProps.selectedRecord) {
      let { inputGroups, grade } = state
      let newStructureData = Object.entries(inputGroups).reduce((orgGroups, structure) => {
        let [orgGroupKey, orgGroupAttrs] = structure
        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (!orgGroupAttrs.validation || !orgGroupAttrs.validation.required) {
          valid = true
        }
        if (orgGroupAttrs.elementType === 'datePicker') {
          if (props.selectedRecord !== null) {
            value = new Date(props.selectedRecord[orgGroupKey])
          }
        }
        if (orgGroupAttrs.elementType === 'checkbox') {
          value = false
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[orgGroupKey]) {
          value = props.selectedRecord[orgGroupKey]
          let { isValid, error } = checkValidity(
            value,
            orgGroupAttrs.validation,
            orgGroupAttrs.label
          )
          if (orgGroupAttrs.elementType === 'newselect') {
            value =
              state.inputGroups[orgGroupKey].elementConfig.options.find(
                res => res.value === value
              ) || value
          }
          if (orgGroupAttrs.elementType === 'newmultiSelect') {
            value = value.map(dat => {
              return inputGroups[orgGroupKey].elementConfig.options.find(
                res => res.value === dat.role_id
              )
            })
          }
          if (orgGroupAttrs.elementType === 'checkbox') {
            value = !!value
          }
          valid = isValid
          errorMessage = error
        }

        const newStructureAttrs = {
          ...orgGroupAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }
        return updateObject(orgGroups, { [orgGroupKey]: { ...newStructureAttrs } })
      }, {})
      let sum = 0
      if (props.selectedRecord?.vfr_budget && props.selectedRecord?.vfr_budget.length > 0) {
        grade = props.selectedRecord.vfr_budget.map(item => {
          return {
            grade_id: item.grade_id,
            budget_percent: item.budget_percent
          }
        })
        grade.map(item => {
          sum = sum + (+item?.budget_percent || 0)
          return item
        })
      }
      updatedState = {
        ...updatedState,
        grade: grade,
        totalValid: sum === 100,
        formValid: true,
        inputGroups: newStructureData,
        updateProps: { ...updateProps, selectedRecord: props.selectedRecord }
      }
    }
    return updatedState
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchForceRankGroup(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchForceRankGroup(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }
  clearInput = () => {
    let newFormData = Object.entries(this.state.inputGroups).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form
      let newFormAttrs
      switch (formKey) {
        case 'effective_date':
          newFormAttrs = {
            ...formAttrs,
            value: moment(new Date(), 'YYYY-MM-DD').format('DD MMM YYYY')
          }
          break
        default:
          newFormAttrs = {
            ...formAttrs,
            value: ''
          }
          break
      }

      return updateObject(formGroups, { [formKey]: { ...newFormAttrs } })
    }, {})

    this.setState({
      inputGroups: newFormData
    })
  }
  openModalHandler = (action, recordId) => {
    if (recordId && action === 'edit') {
      this.props.fetchForceRankGroupById(recordId)
    }
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }
  openModal = () => {
    this.setState({
      modalOpen: true,
      formValid: false
    })
  }
  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    this.clearInput()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        actionRecordId: null,
        grade: [],
        formValid: false,
        addAno: false
      })
    } else {
      this.setState({
        actionRecordId: null,
        grade: [],
        formValid: false,
        modalOpen: false
      })
    }
  }

  orgGroupSubmitHandler = type => {
    let orgGroupData = Object.entries(this.state.inputGroups).reduce(
      (orgGroupData, orgGroupEntry) => {
        let [orgGroupKey, orgGroupAttrs] = orgGroupEntry
        let value = ''
        if (orgGroupAttrs.elementType === 'newselect') {
          value = orgGroupAttrs.value?.value
        } else if (orgGroupAttrs.elementType === 'newmultiSelect') {
          value = orgGroupAttrs.value.map(res => {
            return { role_id: res.value }
          })
        } else if (
          orgGroupAttrs.elementType === 'datePicker' &&
          typeof orgGroupAttrs.value !== 'string'
        ) {
          value = moment(orgGroupAttrs.value || new Date(), 'YYYY-MM-DD').format('DD MMM YYYY')
        } else if (orgGroupKey === 'thresholds') {
          value = orgGroupAttrs.value.map(item => {
            return {
              start_value: item.start_value,
              end_value: item.end_value,
              color_code: item.color_code
            }
          })
        } else {
          value = orgGroupAttrs.value
        }
        return { ...orgGroupData, [orgGroupKey]: value }
      },
      {}
    )
    let recordData = {
      fr_group: { ...orgGroupData },
      vrf_budget: this.state.grade
    }
    if (this.state.action === 'add') {
      this.props.createForceRankGroup(recordData, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else if (this.state.action === 'edit') {
      this.props.updateForceRankGroup(
        this.state.actionRecordId,
        recordData,
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  inputChangeHandler = (orgGroupKey, event) => {
    const inputGroup = this.state.inputGroups

    const orgGroupItem = inputGroup[orgGroupKey]

    let inputValue = ''

    switch (orgGroupItem.elementType) {
      case 'textEditor':
        inputValue = event.target.getContent()
        break
      case 'newselect':
        inputValue = event
        break
      case 'datePicker':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !orgGroupItem.value
        break
      case 'newmultiSelect':
        inputValue = event
        break

      default:
        inputValue = event.target.value
        break
    }

    const { isValid, error } = checkValidity(
      inputValue,
      orgGroupItem.validation,
      orgGroupItem.label
    )

    let updatedStructureItem = {
      ...orgGroupItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }
    const updateGroup = updateObject(inputGroup, { [orgGroupKey]: updatedStructureItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    let newStructure = inputGroup

    newStructure = updateObject(newStructure, { [orgGroupKey]: updatedStructureItem })

    this.setState({
      inputGroups: newStructure,
      formValid: formIsValid
    })
  }

  inputChange = (inputKey, event) => {
    let updateInputGroups = this.state.groups
    if (inputKey !== 'color_code') {
      updateInputGroups[inputKey].value = event.target.value
    } else {
      updateInputGroups[inputKey].value = event
    }

    this.setState({
      groups: updateInputGroups
    })
  }

  addGroup = () => {
    let updateInputGroups = this.state.inputGroups

    updateInputGroups.thresholds.value.push({
      start_value: this.state.groups.start_value.value,
      end_value: this.state.groups.end_value.value,
      color_code: this.state.groups.color_code.value
    })
    this.setState({
      inputGroups: updateInputGroups
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  openConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()

    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      filter: []
    })
  }
  deleteRecord = () => {
    const recordId = this.state.actionRecordId
    this.props.deleteForceRankGroup(recordId, getPageStatus(this.props.pagination, true))
    this.closeConfirmationModal()
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    if (itemKey === 'company_id') {
      this.props.fetchFilter({ company_id: filterValue?.value })
    }
    this.setState(
      {
        filterControls: updateObject(this.state.filterControls, {
          [itemKey]: {
            ...filterItem,
            value: filterValue
          }
        }),
        filter: {
          ...this.state.filter,
          [itemKey === 'fr_group_id' ? 'fr_group_name' : itemKey]:
            itemKey === 'fr_group_id' ? filterValue?.label : filterValue?.value
        }
      },
      () => {
        this.props.fetchFilter(this.state.filter)
      }
    )
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    this.props.fetchForceRankGroup(this.state.filter)
    this.closeFilterModal()
  }

  gradeChanged = (id, e) => {
    let grade = this.state.grade
    let check = grade.find(item => item.grade_id === id)

    if (!check) {
      grade.push({ grade_id: id, budget_percent: +e.target.value || '' })
    } else {
      grade = grade.map(item => {
        if (item.grade_id === id) {
          return {
            ...item,
            budget_percent: e.target.value === '' ? '' : e.target.value
          }
        }
        return item
      })
    }
    let sum = 0
    grade.map(item => {
      sum = sum + (+item?.budget_percent || 0)
      return item
    })
    this.setState({
      grade: grade,
      totalValid: sum === 100
    })
  }

  render() {
    let form = <Spinner />
    if (this.state.action === 'edit') {
      if (this.props.selectedRecord && !this.props.loading) {
        form = (
          <Form
            gradeData={this.props.gradeData}
            grade={this.state.grade}
            inputGroups={this.state.inputGroups}
            inputChanged={(key, e) => this.inputChangeHandler(key, e)}
            gradeChanged={(id, e) => this.gradeChanged(id, e)}
          />
        )
      }
    } else if (!this.props.loading) {
      form = (
        <Form
          gradeData={this.props.gradeData}
          grade={this.state.grade}
          inputGroups={this.state.inputGroups}
          inputChanged={(key, e) => this.inputChangeHandler(key, e)}
          gradeChanged={(id, e) => this.gradeChanged(id, e)}
        />
      )
    }

    const footer = (
      <Footer
        save={() => this.orgGroupSubmitHandler('save')}
        another={() => this.orgGroupSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!(validateForm(this.state.inputGroups) && this.state.totalValid)}
      />
    )
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('forceRankGroup')}
          backdropClicked={this.closeModal}
          size={'md'}
          footer={footer}>
          {form}
        </Modal>
        <Card>
          <CardHeader>
            <FilterBar buttonClicked={this.openFilterModal} />
          </CardHeader>
          <CardBody>
            <DataTable
              tableTitle={this.props.translate('forceRankGroup')}
              data={this.props.data}
              structure={this.tableStructure}
              loading={this.props.loadingQueue.includes('record')}
              pagination={this.props.pagination}
              pageChange={this.onPageChangeHandler}
              perPageChange={this.onPerPageChangeHandler}
              rowActions={this.rowActions}
            />
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.forceRankGroup.pagination,
    data: state.forceRankGroup.records,
    loading: state.forceRankGroup.loading,
    filterLoading: state.forceRankGroup.filterLoading,
    success: state.forceRankGroup.success,
    selectedRecord: state.forceRankGroup.selectedRecord,
    companyOptions: state.forceRankGroup.company,
    resultTypeOptions: state.forceRankGroup.resultType,
    filterForceRankGroup: state.forceRankGroup.filterForceRankGroup,
    loadingQueue: state.forceRankGroup.loadingStates,
    gradeData: state.forceRankGroup.gradeData,
    forceRankGroup: state.forceRankGroup
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForceRankGroup: filterOptions => dispatch(actions.fetchForceRankGroup(filterOptions)),
    fetchForceRankGroupById: recordId => dispatch(actions.fetchForceRankGroupById(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedForceRankGroupRecord()),
    createForceRankGroup: (recordData, page) =>
      dispatch(actions.createForceRankGroup(recordData, page)),
    updateForceRankGroup: (recordId, recordData, page) =>
      dispatch(actions.updateForceRankGroup(recordId, recordData, page)),
    deleteForceRankGroup: (recordId, page) =>
      dispatch(actions.deleteForceRankGroup(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchResultTypeOptions())
      dispatch(actions.fetchGradeOptions())
    },
    fetchFilter: filter => {
      dispatch(actions.fetchForceRankGroupFilterForceRankGroup(filter))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ForceRankGroup))
